// extracted by mini-css-extract-plugin
export default {"container":"Notebook__container--Y7bWqeRMSX"};